import React from 'react';
import { Container } from 'reactstrap';
import TenderOpening from './components/TenderOpening';

const TenderOpeningPage = () => {
  document.title = 'Tender Opening';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <TenderOpening />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TenderOpeningPage;
